import { render, staticRenderFns } from "./page-list.vue?vue&type=template&id=0e66a2ea&scoped=true&"
import script from "./page-list.vue?vue&type=script&lang=js&"
export * from "./page-list.vue?vue&type=script&lang=js&"
import style0 from "./page-list.vue?vue&type=style&index=0&id=0e66a2ea&scoped=true&lang=css&"
import style1 from "./page-list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e66a2ea",
  null
  
)

export default component.exports